/**
 * Created by Gayratjon Rayimjonov on 6/14/2017.
 */
(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('StatsProfitMargin', StatsProfitMargin);

    StatsProfitMargin.$inject = ['$resource', 'DateUtils'];

    function StatsProfitMargin ($resource, DateUtils) {
        var resourceUrl =  'api/stats-profit';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fromDate = DateUtils.convertLocalDateFromServer(data.fromDate);
                        data.toDate = DateUtils.convertLocalDateFromServer(data.toDate);
                    }
                    return data;
                }
            }
        });
    }
})();
